import { BrokenLinkReport } from '®shared/list-item/report-broken-link-modal/broken-link-report';

import { AnalyticsEvent } from './analytics-event';

export const REPORT_BROKEN_LINK_SUCCESS_EVENT_CLASS =
  'list.item.report_broken_link';
type ReportBrokenLinkSuccessEventClass =
  typeof REPORT_BROKEN_LINK_SUCCESS_EVENT_CLASS;

export interface ReportBrokenLinkSuccessEventProps {
  item_id: string;
  has_user_added_details: boolean;
  has_user_added_email: boolean;
  user_screen_resolution: string;
  user_agent: string;
}

export interface ReportBrokenLinkSuccessEvent extends AnalyticsEvent {
  className: ReportBrokenLinkSuccessEventClass;
  props: ReportBrokenLinkSuccessEventProps;
}

export function createReportBrokenLinkSuccessEvent(
  brokenLinkReport: BrokenLinkReport,
): ReportBrokenLinkSuccessEvent {
  return {
    className: REPORT_BROKEN_LINK_SUCCESS_EVENT_CLASS,
    props: {
      item_id: brokenLinkReport.item.id,
      has_user_added_details: brokenLinkReport.details ? true : false,
      has_user_added_email: brokenLinkReport.reporter_email ? true : false,
      user_screen_resolution: brokenLinkReport.screen_resolution,
      user_agent: brokenLinkReport.user_agent,
    },
  };
}

export const REPORT_BROKEN_LINK_CANCEL_EVENT_CLASS =
  'list.item.cancel_report_broken_link';
type ReportBrokenLinkCancelEventClass =
  typeof REPORT_BROKEN_LINK_CANCEL_EVENT_CLASS;

export interface ReportBrokenLinkCancelEventProps {
  item_id: string;
  user_screen_resolution: string;
  user_agent: string;
}

export interface ReportBrokenLinkCancelEvent extends AnalyticsEvent {
  className: ReportBrokenLinkCancelEventClass;
  props: ReportBrokenLinkCancelEventProps;
}

export function createReportBrokenLinkCancelEvent(
  itemId: string,
  screenResolution: string,
  userAgent: string,
): ReportBrokenLinkCancelEvent {
  return {
    className: REPORT_BROKEN_LINK_CANCEL_EVENT_CLASS,
    props: {
      item_id: itemId,
      user_screen_resolution: screenResolution,
      user_agent: userAgent,
    },
  };
}
